import HTTP from "@/_helpers/http";
import { MAMWALLET__API } from "@/_helpers/urls";
import { MAMWALLET__MUTATIONS } from "../mutation-types";
import { MAMWALLET__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  withdrawal: [],
  dashboardwithdrawal: [],
  totalCount: 0,
  paymentMethods: [],
  isLoading: false,
  isDashboardWithdrawLoading: false,
  totalWithdrawal: 0,
  totalWithdrawalCount: 0,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [MAMWALLET__MUTATIONS.WALLETTRX](state, data) {
    state.withdrawal = data?.data?.summaries;
    state.totalCount = data?.data?.summaries?.length;
    state.paymentMethods = data?.data?.paymentMethods;
    state.totalWithdrawal = data?.data?.totalWithdrawal;
    state.pagination = data?.data?.pagination;
    state.totalWithdrawalCount = data?.data?.pagination?.total;
  },
  [MAMWALLET__MUTATIONS.TRXDASHBOARDWITHDRAWAL](state, data) {
    state.dashboardwithdrawal = data?.data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_ISDASH_WITHDRAW_LOADING(state, data) {
    state.isDashboardWithdrawLoading = data;
  },
};

// Actions
const actions = {
  async [MAMWALLET__ACTIONS.WALLETTRX]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        method_name,
        trx_type,
        duration,
        status,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(method_name && { method_name }),
        ...(trx_type && { trx_type }),
        ...(duration && { duration }),
        ...(status && { status }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${MAMWALLET__API.WALLETTRX}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(MAMWALLET__MUTATIONS.WALLETTRX, response.data);
    } catch (error) {
      console.log(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async [MAMWALLET__ACTIONS.UPDATEWALLETWITHDRAW](
        { state, commit, dispatch },
        parameter
    ) {
        try {
        commit("SET_UPDATE_LOADING", true);
        const response = await HTTP().patch(
            MAMWALLET__API.UPDATEWALLETWITHDRAW,
            parameter
        );

        toast.success(response.data.message);
        await dispatch(MAMWALLET__ACTIONS.WALLETTRX);
        } catch (error) {
        console.error(error);
        } finally {
        commit("SET_UPDATE_LOADING", false);
        }
    },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
